import React from 'react';
import Navbar from 'components/Header/Navbar';
import CorporateProfileForm from 'components/Profile/CorporateProfileForm';
import ProfileCard from 'components/Profile/ProfileCard';
import Footer from 'components/Footer';

const Profil_kurumsal: React.FC = () => {
  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      <Navbar />
      <main className="container py-4">
        <div className="row">
          <ProfileCard />
          <div className="col-lg-8">
            <CorporateProfileForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Profil_kurumsal;
